module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodsList",
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.showPage) ? _c('div', [_c('div', {
    class: ['main', {
      'no-foot': _vm.showBlock != 'orderDishes'
    }]
  }, [_c('div', {
    staticClass: "top-area",
    staticStyle: {
      "margin-bottom": "0.5rem"
    },
    attrs: {
      "id": "topArea"
    },
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  }, [_c('div', {
    staticClass: "bg-pic-box"
  }, [_c('div', {
    staticClass: "bg-pic",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }, [_c('div', {
    staticClass: "top-area-mask"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "shop-img",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-info fl"
  }, [_c('div', {
    staticClass: "shop-des"
  }, [_c('div', {
    staticClass: "flexrow ellipse",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("起送 ￥" + _vm._s(_vm.shopDetail.threshold_amount))]), _c('span', {
    staticStyle: {
      "margin": "0 0.05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v(" "), (_vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                  ")]) : _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.shopDetail.delivery_fee))]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.delivery_type == 1) ? _c('span', [_vm._v("(商家配送)")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 0.05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v("月售" + _vm._s(_vm.shopDetail.sales_append) + "单\n                ")], 2), _vm._v(" "), (_vm.shopDetail.announcement && !_vm.shopDetail.dinner_duration) ? _c('div', {
    staticClass: "announcement"
  }, [_vm._v("\n                公告：" + _vm._s(_vm.shopDetail.announcement) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.dinner_duration) ? _c('div', {
    staticStyle: {
      "font-size": ".22rem",
      "width": "100%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.shopDetail.dinner_duration) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), ((_vm.couponInfo.coupon_list && _vm.couponInfo.coupon_list.length > 0) || _vm.shopDetail.promotion_package) ? _c('div', {
    staticClass: "shop-coupon"
  }, [(_vm.shopDetail.promotion_package && _vm.shopDetail.promotion_package.length > 0) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.shopDetail.promotion_package), function(coupon, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-item package",
      class: {
        checked: coupon.status == 1
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(coupon)
        }
      }
    }, [_c('div', {
      staticClass: "fs-20"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-40 fw-bold"
    }, [_vm._v(_vm._s(coupon.package_price))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0 .15rem"
      }
    }, [_c('div', {
      staticClass: "fs-24 ellipse"
    }, [_vm._v(_vm._s(coupon.promotion_name))]), _vm._v(" "), _c('div', {
      staticClass: "fs-18 ellipse"
    }, [_vm._v(_vm._s(coupon.package_desc))])]), _vm._v(" "), (coupon.status == 1) ? _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": require("../assets/images/img_line_coupon_red.png")
      }
    }) : _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": require("../assets/images/img_line_coupon_white.png")
      }
    }), _vm._v(" "), (coupon.status == 1) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("已购")]) : _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("超值购")])])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._l((_vm.couponInfo.coupon_list), function(coupon, index) {
    return _c('div', {
      key: index,
      staticClass: "coupon-item",
      class: {
        checked: coupon.status == 1 || coupon.status == 2
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.receiveCoupon(coupon)
        }
      }
    }, [_c('div', {
      staticClass: "fs-20"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-40 fw-bold"
    }, [_vm._v(_vm._s(coupon.couponAmount))]), _vm._v(_vm._s(coupon.decimal ? '.' + coupon.decimal : '') + "\n              ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0 .15rem"
      }
    }, [_c('div', {
      staticClass: "fs-24"
    }, [_vm._v(_vm._s(coupon.couponName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-18 ellipse"
    }, [_vm._v(_vm._s(coupon.amountCondition))])]), _vm._v(" "), (coupon.status == 1 || coupon.status == 2) ? _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": require("../assets/images/img_line_coupon_red.png")
      }
    }) : _c('img', {
      staticClass: "c-line",
      attrs: {
        "src": require("../assets/images/img_line_coupon_white.png")
      }
    }), _vm._v(" "), (coupon.status == 1) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("已领")]) : (coupon.status == 2) ? _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("不可领")]) : _c('div', {
      staticClass: "fs-18 ac",
      staticStyle: {
        "width": ".8rem"
      }
    }, [_vm._v("领")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', [((_vm.shopDetail.promotion_list && _vm.shopDetail.promotion_list.length > 0) || _vm.shopDetail.promotion_reduce) ? _c('div', {
    staticClass: "activity-info"
  }, [_c('div', {
    staticClass: "special-goods arrow-down flexrow",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "75%"
    }
  }, [(_vm.shopDetail.promotion_list1) ? _c('div', {
    staticClass: "promotion_reduce"
  }, _vm._l((_vm.shopDetail.promotion_list1), function(item) {
    return _c('span', {
      staticClass: "promotion_reduce-type border"
    }, [_vm._v(_vm._s(item))])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0) ? _c('span', {
    staticClass: "activities fr"
  }, [_vm._v("共" + _vm._s(_vm.shopDetail.promotion_list ? (_vm.shopDetail.promotion_list.length + 1) : 1) + "个活动")]) : _c('span', {
    staticClass: "activities fr"
  }, [_vm._v("共" + _vm._s(_vm.shopDetail.promotion_list.length) + "个活动")])])]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.announcement && _vm.shopDetail.dinner_duration) ? _c('div', {
    staticClass: "announcement",
    staticStyle: {
      "margin-left": ".26rem",
      "color": "#999"
    }
  }, [_vm._v("公告：" + _vm._s(_vm.shopDetail.announcement) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar col33",
    staticStyle: {
      "margin-top": "0.3rem"
    },
    attrs: {
      "id": "checkTab"
    }
  }, [_c('a', {
    class: {
      active: _vm.showBlock == 'orderDishes'
    },
    attrs: {
      "id": "orderDishes"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showBlock == 'commentInfo'
    },
    attrs: {
      "id": "commentInfo"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("评价")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.showBlock == 'shopInfo'
    },
    attrs: {
      "id": "shopInfo"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("商家")]), _vm._v(" "), _c('div', {
    staticClass: "shop-search",
    on: {
      "click": function($event) {
        return _vm.toShopSearch()
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'orderDishes'),
      expression: "showBlock == 'orderDishes'"
    }],
    staticClass: "content"
  }, [(_vm.req_type) ? _c('div', [_c('div', {
    staticClass: "goods-list1",
    attrs: {
      "id": "goodList"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      "id": "scroller"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.myGoodsList), function(item1) {
    return (item1.goods_list && item1.goods_list.length) ? _c('ul', {
      staticStyle: {
        "border": "none"
      },
      attrs: {
        "id": "myUl"
      }
    }, [_vm._l((item1.goods_list), function(item, index) {
      return _c('li', {
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "id": item.tag_id + 'goods' + index
        }
      }, [_c('div', {
        staticClass: "goods-box",
        class: item.gd_code == _vm.gdCode ? 'isHightGood' : '',
        on: {
          "click": function($event) {
            return _vm.toggleProp('goodInfo', item)
          }
        }
      }, [_c('div', {
        staticClass: "goods-img"
      }, [_c('div', {
        staticClass: "lazy goodimg",
        style: ({
          backgroundImage: 'url(' + item.image_url + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-des flexrow",
        staticStyle: {
          "padding-right": "0"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), (item.activity_specification && item.is_single_spec == 0) ? _c('p', [_vm._v("\n                          " + _vm._s(item.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item.sales_volume))]), _vm._v(" "), _c('div', {
        staticClass: "flexrow",
        staticStyle: {
          "justify-content": "space-between",
          "align-items": "center"
        }
      }, [(item.activity_id > 0) ? _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item.price))])]) : _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item.price))]), _vm._v(" "), (item.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item.sales_status == 1 && item.stock > 0) ? _c('div', {
        staticClass: "num-box"
      }, [(item.is_options == 1) ? _c('div', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleProp('specInfo', item)
          }
        }
      }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item.cartNum > 0) ? _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s(item.cartNum))]) : _vm._e()]) : _c('div', [(item.cartNum > 0) ? _c('span', {
        staticClass: "btns minusBtn icon-removecart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.minusGoods(item)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item.cartNum > 0) ? _c('span', {
        staticClass: "box"
      }, [_vm._v(_vm._s(item.cartNum))]) : _vm._e(), _vm._v(" "), (item.smallNumber > 1 && !item.cartNum) ? _c('span', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item)
          }
        }
      }, [_vm._v(_vm._s(item.smallNumber) + "份起购")]) : (!item.noStock || item.smallNumber <= 1 && !item.cartNum) ? _c('span', {
        staticClass: "btns addBtn icon-addtocart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item)
          }
        }
      }) : _c('span', {
        staticClass: "btns addBtn icon-cantaddtocart"
      })])]) : _c('span', {
        staticClass: "num-box sales-out"
      }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item.activity_desc) ? _c('div', {
        staticClass: "sale-box"
      }, [(item.activity_desc && item.activity_desc != '') ? _c('span', {
        staticClass: "no-bg"
      }, [_vm._v(_vm._s(item.activity_desc))]) : _vm._e(), _vm._v(" "), (item.activity_id > 0 && item.sales_status == 1 && item.left_stock <= 10) ? _c('span', {
        staticClass: "bg"
      }, [_vm._v("剩" + _vm._s(item.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "1.26rem",
          "margin-top": "0.1rem"
        }
      }, [(item.partner != 0 && item.activity_desc_extra) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item.show_text) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item.show_text))]) : _vm._e()])])])
    }), _vm._v(" "), (_vm.noMore) ? _c('li', {
      staticClass: "no-more"
    }, [_vm._v("没有更多内容啦~请切换下一个分类")]) : _vm._e()], 2) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "side-bar",
    attrs: {
      "id": "sideBar1"
    }
  }, [_c('div', {
    staticClass: "side-bar-scroll",
    attrs: {
      "id": "scrollBox1"
    }
  }, _vm._l((_vm.myGoodsList), function(item) {
    return _c('a', {
      class: {
        active: item.isActive
      },
      attrs: {
        "id": item.tag_name
      },
      on: {
        "click": function($event) {
          return _vm.scrollGoods1(item)
        }
      }
    }, [(item.is_special_tag > 0) ? _c('span', {
      staticClass: "icon icon-sale"
    }, [_vm._v(_vm._s(item.tag_name_short))]) : _c('span', [_vm._v(_vm._s(item.tag_name_short))]), _vm._v(" "), (item.tagNum > 0 && item.is_special_tag <= 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.tagNum))]) : _vm._e()])
  }), 0)])]) : _c('div', [_c('div', {
    staticClass: "goods-list",
    attrs: {
      "id": "goodList"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    },
    attrs: {
      "id": "scroller"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('ul', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('li', {
      staticClass: "title",
      attrs: {
        "id": item.tag_id
      }
    }, [_vm._v(_vm._s(item.tag_name))]), _vm._v(" "), _vm._l((item.goods_list), function(item2, index) {
      return _c('li', {
        staticStyle: {
          "border": "none"
        },
        attrs: {
          "id": item.tag_id + 'goods' + index
        }
      }, [_c('div', {
        staticClass: "goods-box",
        class: item2.gd_code == _vm.gdCode ? 'isHightGood' : '',
        on: {
          "click": function($event) {
            return _vm.toggleProp('goodInfo', item2)
          }
        }
      }, [_c('div', {
        staticClass: "goods-img"
      }, [_c('div', {
        staticClass: "lazy goodimg",
        style: ({
          backgroundImage: 'url(' + item2.image_url + ')'
        })
      })]), _vm._v(" "), _c('div', {
        staticClass: "goods-des flexrow",
        staticStyle: {
          "padding-right": "0"
        }
      }, [_c('div', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item2.goods_name))]), _vm._v(" "), (item2.activity_specification && item2.is_single_spec == 0) ? _c('p', [_vm._v("\n                          " + _vm._s(item2.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item2.sales_volume))]), _vm._v(" "), _c('div', {
        staticClass: "flexrow",
        staticStyle: {
          "justify-content": "space-between",
          "align-items": "center"
        }
      }, [(item2.activity_id > 0) ? _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item2.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item2.price))])]) : _c('p', [_c('span', {
        staticClass: "price amounts",
        staticStyle: {
          "font-weight": "bold"
        }
      }, [_vm._v("￥" + _vm._s(item2.price))]), _vm._v(" "), (item2.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item2.sales_status == 1 && item2.stock > 0) ? _c('div', {
        staticClass: "num-box"
      }, [(item2.is_options == 1) ? _c('div', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleProp('specInfo', item2)
          }
        }
      }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e()]) : _c('div', [(item2.cartNum > 0) ? _c('span', {
        staticClass: "btns minusBtn icon-removecart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.minusGoods(item2)
          }
        }
      }) : _vm._e(), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
        staticClass: "box"
      }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e(), _vm._v(" "), (item2.smallNumber > 1 && !item2.cartNum) ? _c('span', {
        staticClass: "btn-yellow select-spec-btn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item2)
          }
        }
      }, [_vm._v(_vm._s(item2.smallNumber) + "份起购")]) : (!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum) ? _c('span', {
        staticClass: "btns addBtn icon-addtocart",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.addGoods(item2)
          }
        }
      }) : _c('span', {
        staticClass: "btns addBtn icon-cantaddtocart"
      })])]) : _c('span', {
        staticClass: "num-box sales-out"
      }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item2.activity_desc) ? _c('div', {
        staticClass: "sale-box"
      }, [(item2.activity_desc && item2.activity_desc != '') ? _c('span', {
        staticClass: "no-bg"
      }, [_vm._v(_vm._s(item2.activity_desc))]) : _vm._e(), _vm._v(" "), (item2.activity_id > 0 && item2.sales_status == 1 && item2.left_stock <= 10) ? _c('span', {
        staticClass: "bg"
      }, [_vm._v("剩" + _vm._s(item2.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
        staticStyle: {
          "padding-left": "1.26rem",
          "margin-top": "0.1rem"
        }
      }, [(item2.partner != 0 && item2.activity_desc_extra) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item2.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item2.show_text) ? _c('span', {
        staticClass: "activity-tip"
      }, [_vm._v(_vm._s(item2.show_text))]) : _vm._e()])])])
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "side-bar",
    attrs: {
      "id": "sideBar"
    }
  }, [_c('div', {
    staticClass: "side-bar-scroll",
    attrs: {
      "id": "scrollBox"
    }
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('a', {
      class: {
        active: item.isActive
      },
      attrs: {
        "id": item.tag_name
      },
      on: {
        "click": function($event) {
          return _vm.scrollGoods(item)
        }
      }
    }, [(item.is_special_tag > 0) ? _c('span', {
      staticClass: "icon icon-sale"
    }, [_vm._v(_vm._s(item.tag_name_short))]) : _c('span', [_vm._v(_vm._s(item.tag_name_short))]), _vm._v(" "), (item.tagNum > 0 && item.is_special_tag <= 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item.tagNum))]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'commentInfo'),
      expression: "showBlock == 'commentInfo'"
    }],
    staticClass: "content3 usercenter",
    attrs: {
      "id": "content3"
    }
  }, [_c('div', [_c('div', {
    staticClass: "shop-comment"
  }, [_c('span', [_vm._v(_vm._s(_vm.shopDetail.score))]), _vm._v(" "), _c('CommentStars', {
    attrs: {
      "qualityCode": _vm.shopDetail.score
    }
  }), _vm._v(" "), (_vm.CommentNum != '') ? _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.CommentNum) + "名同学参与菜品反馈")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.businessCommentList.length) ? _c('ul', {
    staticClass: "comments-list"
  }, _vm._l((_vm.businessCommentList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: 'url(' + item.userPhotoUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "font-size": "0.22rem",
        "color": "#797979",
        "align-items": "center"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.1rem"
      }
    }, [_vm._v("评分")]), _vm._v(" "), _c('CommentStars', {
      attrs: {
        "qualityCode": item.qualityCode
      }
    })], 1), _vm._v(" "), (item.comment != '') ? _c('div', {
      staticClass: "des"
    }, [_vm._v(_vm._s(item.comment))]) : _vm._e(), _vm._v(" "), _c('PreviewPicture', {
      attrs: {
        "previewPictures": item.urls
      }
    }), _vm._v(" "), (item.goodsMarkList.length > 0) ? _c('div', {
      staticClass: "goodsmark_list"
    }, [(item.goodList.length > 0) ? _c('div', [_c('span', {
      staticClass: "icon good"
    }), _vm._v(" "), _c('p', _vm._l((item.goodList), function(item1, index) {
      return _c('span', [_vm._v(_vm._s(item1)), (index < item.goodList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (item.badList.length > 0) ? _c('div', [_c('span', {
      staticClass: "icon bad"
    }), _vm._v(" "), _c('p', _vm._l((item.badList), function(item2, index) {
      return _c('span', [_vm._v(_vm._s(item2)), (index < item.badList.length - 1) ? _c('span', [_vm._v("，")]) : _vm._e()])
    }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.isReply == 1) ? _c('div', {
      staticClass: "reply_comment"
    }, [_vm._v("商家回复：" + _vm._s(item.replyComment))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))])], 1)])
  }), 0) : _c('div', {
    staticStyle: {
      "position": "relative",
      "height": "10rem",
      "text-align": "center"
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlock == 'shopInfo'),
      expression: "showBlock == 'shopInfo'"
    }],
    staticClass: "content2 usercenter",
    attrs: {
      "id": "content2"
    }
  }, [_c('div', [_c('div', {
    staticClass: "shop-info"
  }, [_c('h3', [_vm._v("商家信息")]), _vm._v(" "), _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商家电话:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.shopDetail.service_tel))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("商家地址:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.shopDetail.address))])]), _vm._v(" "), (_vm.shopDetail.open_rules == 0 && _vm.shopDetail.open_setting != null) ? _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("营业时间:")]), _c('span', {
    staticClass: "con"
  }, [_vm._v(_vm._s(_vm.openTime))])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.open_rules == 1 && _vm.shopDetail.weeks_no && _vm.shopDetail.weeks_no.length > 0) ? _c('div', {
    staticClass: "shop-info-box"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("营业时间:")]), _vm._v(" "), _c('div', {
    staticClass: "con"
  }, _vm._l((_vm.shopDetail.weeks_no), function(item) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(item.weekstr))]), _vm._v(" "), _vm._l((item.open_setting), function(item2) {
      return _c('p', [_vm._v("\n                      " + _vm._s(item2.begin_time) + "-" + _vm._s(item2.end_time) + "\n                    ")])
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.aptitude && _vm.shopDetail.aptitude.license_list && _vm.shopDetail.aptitude.license_list.length > 0) ? _c('div', [_c('span', {
    staticClass: "license"
  }, [_vm._v("营业执照:")]), _vm._v(" "), _c('PreviewPicture', {
    attrs: {
      "previewPictures": _vm.shopDetail.aptitude.license_url_list
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.shopDetail.aptitude && _vm.shopDetail.aptitude.food_license_list && _vm.shopDetail.aptitude.food_license_list.length > 0) ? _c('div', [_c('span', {
    staticClass: "license"
  }, [_vm._v("食品经营许可证(食品流通许可证):")]), _vm._v(" "), _c('PreviewPicture', {
    attrs: {
      "previewPictures": _vm.shopDetail.aptitude.food_license_url_list
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "list order-list"
  }, [_c('ul', _vm._l((_vm.shopDetail.other_info), function(item) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.showOtherInfo(item)
        }
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "icon_arrow_next fr"
    })])])
  }), 0)])])]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(_vm.showBlock == 'orderDishes') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "fixed",
      "bottom": "1rem",
      "left": "0",
      "z-index": "18"
    }
  }, [(_vm.cartInfo[_vm.shopCode].total > 0) ? _c('div', [(_vm.shopDetail.promotion_reduce && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [(_vm.nextFullReductionAmountGap != '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元，")]) : _vm._e(), _vm._v("再买"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.nextFullReductionAmountGap) + "元 ")]), _vm._v("减"), _c('span', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.nextFullReductionAmount) + "元")])]) : (_vm.nextFullReductionAmountGap == '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元")]) : _vm._e()]) : _vm._e()]) : (_vm.hasSpecial && _vm.reductionAmount > 0) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_c('span', [_vm._v("特价折扣优惠" + _vm._s(_vm.reductionAmount) + "元")])]) : _vm._e()]) : _c('div', [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0 && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_vm._v("\n              " + _vm._s(_vm.shopDetail.promotion_reduce.promotion_name) + "\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.showBlock == 'orderDishes') ? _c('footer', {
    staticClass: "dark fixed cart flexrow",
    staticStyle: {
      "padding": "0 0.26rem",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "footer-cart"
  }, [_c('div', {
    staticClass: "cart-box-bg"
  }, [(_vm.cartInfo[_vm.shopCode].total <= 0) ? _c('div', {
    staticClass: "cart-box empty"
  }) : _c('div', {
    staticClass: "cart-box",
    attrs: {
      "id": "cart"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toggleProp('cart')
      }
    }
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.cartTotal))])])])]), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 0)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("只能打包自提")])]) : _vm._e(), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 0 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("只能堂食")])]) : _vm._e(), _vm._v(" "), (_vm.cartTotal <= 0 && (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price empty tips"
  }, [_c('span', [_vm._v("支持自提 | 堂食")])]) : (_vm.cartTotal <= 0 && _vm.shopDetail.is_take_out == 1) ? _c('div', {
    staticClass: "price empty tips"
  }, [(_vm.shopDetail.new_delivery_fee === 0 && _vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                另需配送费￥" + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n              ")]) : _c('span', [_vm._v("另需配送费￥" + _vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1) ? _c('span', [_vm._v(" | 支持自提")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_eat_in == 1) ? _c('span', [_vm._v(" | 堂食")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cartTotal > 0) ? _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("￥" + _vm._s(_vm.cartAmount))]), _vm._v(" "), (_vm.cartOriginAmount - _vm.cartAmount > 0) ? _c('span', {
    staticStyle: {
      "text-decoration": "line-through",
      "color": "#797979",
      "font-size": "0.2rem"
    }
  }, [_vm._v("￥" + _vm._s(_vm.cartOriginAmount))]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1 && _vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 0) ? _c('div', {
    staticClass: "tips"
  }, [_c('span', [_vm._v("只能打包自提")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 0 && (_vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price tips"
  }, [_c('span', [_vm._v("只能堂食")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1 && (_vm.shopDetail.is_take_out == 0 && _vm.shopDetail.is_eat_in == 1)) ? _c('div', {
    staticClass: "price tips"
  }, [_c('span', [_vm._v("支持自提 | 堂食")])]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_take_out == 1) ? _c('div', {
    staticClass: "tips"
  }, [(_vm.shopDetail.new_delivery_fee === 0 && _vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                  另需配送费￥" + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                ")]) : _c('span', [_vm._v("另需配送费￥" + _vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_self_take_new == 1) ? _c('span', [_vm._v(" | 支持自提")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.is_eat_in == 1) ? _c('span', [_vm._v(" | 堂食")]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [(_vm.cartTotal <= 0) ? _c('div', {
    staticClass: "btn btn-gray btn-lg fr"
  }, [_vm._v("去结算")]) : _c('div', [(_vm.spreadPrice <= 0 && _vm.hasNeedChoose) ? _c('div', {
    staticClass: "btn btn-main btn-lg fr",
    on: {
      "click": _vm.settleAccounts
    }
  }, [_vm._v("\n                去结算\n              ")]) : _vm._e(), _vm._v(" "), (_vm.spreadPrice <= 0 && !_vm.hasNeedChoose) ? _c('div', {
    staticClass: "btn btn-main btn-lg fr",
    staticStyle: {
      "font-size": ".28rem"
    },
    on: {
      "click": _vm.settleAccounts
    }
  }, [_vm._v("\n                未点必选品\n              ")]) : _vm._e(), _vm._v(" "), (_vm.spreadPrice > 0) ? _c('div', {
    staticClass: "btn btn-gray btn-lg fr",
    staticStyle: {
      "font-size": "0.24rem"
    }
  }, [_vm._v("\n                还差￥" + _vm._s(_vm.spreadPrice) + "起送\n              ")]) : _vm._e()])])]) : _vm._e()]) : _c('div', [_vm._m(2)]), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.toggleProp('cart')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShow) ? _c('div', {
    staticClass: "prop-box cart-list"
  }, [(_vm.cartInfo[_vm.shopCode].total > 0) ? _c('div', [(_vm.shopDetail.promotion_reduce && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [(_vm.nextFullReductionAmountGap != '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元，")]) : _vm._e(), _vm._v("再买"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.nextFullReductionAmountGap) + "元 ")]), _vm._v("减"), _c('span', {
    staticClass: "red"
  }, [_vm._v(" " + _vm._s(_vm.nextFullReductionAmount) + "元")])]) : (_vm.nextFullReductionAmountGap == '') ? _c('div', [(_vm.reductionAmount != '') ? _c('span', [_vm._v("已减" + _vm._s(_vm.reductionAmount) + "元")]) : _vm._e()]) : _vm._e()]) : (_vm.hasSpecial && _vm.reductionAmount > 0) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_c('span', [_vm._v("特价折扣优惠" + _vm._s(_vm.reductionAmount) + "元")])]) : _vm._e()]) : _c('div', [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0 && !_vm.hasSpecial) ? _c('div', {
    staticClass: "promotion_reduce_tips"
  }, [_vm._v("\n            " + _vm._s(_vm.shopDetail.promotion_reduce.promotion_name) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.cartInfo[_vm.shopCode].packFee > 0) ? _c('div', {
    staticClass: "flex-row-sc fl",
    on: {
      "click": function($event) {
        return _vm.viewPackDesc()
      }
    }
  }, [_c('div', {
    staticClass: "fs-24",
    staticStyle: {
      "padding": "0 .1rem"
    }
  }, [_vm._v("打包费"), _c('span', {
    staticClass: "red"
  }, [_vm._v("¥" + _vm._s(_vm.cartInfo[_vm.shopCode].packFee))])]), _vm._v(" "), _c('span', {
    staticClass: "icon-desc"
  }, [_vm._v("?")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "icon icon-delete fr",
    on: {
      "click": _vm.clearCart
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('ul', _vm._l((_vm.shopCartInfo), function(item) {
    return _c('li', [_c('div', {
      staticClass: "rol goods-name",
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("\n              " + _vm._s(item.gdName) + "\n              "), (item.specAttrStr) ? _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(item.specAttrStr))]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "rol pr"
    }, [_vm._v("￥" + _vm._s(item.singleTotalPrice))]), _vm._v(" "), (item.activityId > 0 && item.activeBuyNum > 0) ? _c('del', {
      staticClass: "rol pr"
    }, [_vm._v("￥" + _vm._s(item.singleOriginPrice))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rol num-box"
    }, [_c('span', {
      staticClass: "btns minusBtn icon-removecart",
      on: {
        "click": function($event) {
          return _vm.minusGoods(item)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "box"
    }, [_vm._v(_vm._s(item.cartNum))]), _vm._v(" "), (!item.noStock) ? _c('span', {
      staticClass: "btns addBtn icon-addtocart",
      on: {
        "click": function($event) {
          return _vm.addGoods(item)
        }
      }
    }) : _c('span', {
      staticClass: "btns addBtn icon-cantaddtocart"
    })])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.propShopInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propShopInfo) ? _c('div', {
    staticClass: "alert-box info",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "shop-img",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.pic + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-name"
  }, [_vm._v(_vm._s(_vm.shopDetail.shop_name))]), _vm._v(" "), _c('CommentStars', {
    attrs: {
      "qualityCode": _vm.shopDetail.score
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.shopDetail.score))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 .05rem",
      "color": "#E3E3E3"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("月售" + _vm._s(_vm.shopDetail.sales_append) + "单")]), _vm._v(" "), _c('div', {
    staticClass: "otherInfo",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "font-size": ".22rem"
    }
  }, [_c('div', [_vm._v("起送 ￥" + _vm._s(_vm.shopDetail.threshold_amount))]), _vm._v(" "), _c('div', {
    staticClass: "ml10"
  }, [(_vm.shopDetail.delivery_fee_text) ? _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee_text))]) : [_c('span', [_vm._v("配送￥")]), _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.shopDetail.new_delivery_fee) + "\n                  ")]) : _c('span', [_vm._v(_vm._s(_vm.shopDetail.delivery_fee))]), _vm._v(" "), (_vm.shopDetail.is_many_delivery == 1) ? _c('span', [_vm._v("起")]) : _vm._e()], _vm._v(" "), (_vm.shopDetail.new_delivery_fee || _vm.shopDetail.new_delivery_fee === 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.shopDetail.delivery_fee))]) : _vm._e()], 2), _vm._v(" "), (_vm.shopDetail.delivery_type == 1) ? _c('span', {
    staticClass: "ml10"
  }, [_vm._v("(商家配送)")]) : _vm._e(), _vm._v(" "), (_vm.shopDetail.zsd) ? _c('span', {
    staticClass: "punctual-arrive ml10"
  }, [_vm._v(_vm._s(_vm.shopDetail.zsd))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "special-box",
    staticStyle: {
      "max-height": "50vh",
      "overflow-y": "scroll",
      "overflow-scrolling": "touch",
      "-webkit-overflow-scrolling": "touch"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.shopDetail.promotion_reduce && _vm.shopDetail.promotion_reduce.reduce_info.length > 0) ? _c('div', {
    staticClass: "special-goods",
    style: ({
      backgroundImage: 'url(' + _vm.shopDetail.promotion_reduce.icon_url + ')'
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.shopDetail.promotion_reduce.promotion_name))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shopDetail.promotion_list), function(item) {
    return (_vm.shopDetail.promotion_list && _vm.shopDetail.promotion_list.length > 0) ? _c('div', {
      staticClass: "special-goods",
      style: ({
        backgroundImage: 'url(' + item.icon_url + ')'
      })
    }, [_c('span', [_vm._v(_vm._s(item.promotion_name))])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.shopDetail.announcement) ? _c('div', {
    staticClass: "shopNoticeBox"
  }, [_c('h3', [_vm._v("公告")]), _vm._v(" "), _c('div', {
    staticClass: "special-box",
    staticStyle: {
      "border-top": "none",
      "padding-top": "0"
    }
  }, [_vm._v(_vm._s(_vm.shopDetail.announcement))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "close-box shop-details",
    on: {
      "click": function($event) {
        return _vm.toggleProp('shopInfo')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.propGoodInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('goodInfo')
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propGoodInfo) ? _c('div', {
    staticClass: "alert-box info goods",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsDetail.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pad"
  }, [_c('div', {
    staticClass: "good-name"
  }, [_vm._v(_vm._s(_vm.goodsDetail.goods_name))]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [(_vm.goodsDetail.activity_specification) ? _c('span', [_vm._v(_vm._s(_vm.goodsDetail.activity_specification) + " | ")]) : _vm._e(), _vm._v("\n            销量 " + _vm._s(_vm.goodsDetail.sales_volume) + " | 好评率 " + _vm._s(_vm.goodsDetail.praise_rate) + "%\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "price-box flexrow",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goodsDetail.activity_price))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0) ? _c('del', [_vm._v("￥" + _vm._s(_vm.goodsDetail.price))]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(_vm.goodsDetail.sales_status == 1 && _vm.goodsDetail.stock > 0) ? _c('div', {
    staticClass: "num-box"
  }, [(_vm.goodsDetail.is_options == 1) ? _c('div', {
    staticClass: "btn-yellow select-spec-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleProp('specInfo', _vm.goodsDetail)
      }
    }
  }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.goodsDetail.cartNum))]) : _vm._e()]) : _c('div', [(_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "btns minusBtn icon-removecart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.minusGoods(_vm.goodsDetail)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.cartNum > 0) ? _c('span', {
    staticClass: "box"
  }, [_vm._v(_vm._s(_vm.goodsDetail.cartNum))]) : _vm._e(), _vm._v(" "), (!_vm.goodsDetail.noStock) ? _c('span', {
    staticClass: "btns addBtn icon-addtocart",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addGoods(_vm.goodsDetail)
      }
    }
  }) : _c('span', {
    staticClass: "btns addBtn icon-cantaddtocart"
  })])]) : _c('span', {
    staticClass: "num-box sales-out"
  }, [_vm._v("售罄")])]) : _vm._e()]), _vm._v(" "), (_vm.goodsDetail.activity_desc) ? _c('div', {
    staticClass: "sale-box"
  }, [_c('span', {
    staticClass: "no-bg"
  }, [_vm._v(_vm._s(_vm.goodsDetail.activity_desc))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0 && _vm.goodsDetail.sales_status == 1 && _vm.goodsDetail.left_stock <= 10) ? _c('span', {
    staticClass: "bg"
  }, [_vm._v("剩" + _vm._s(_vm.goodsDetail.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsDetail.detail) ? _c('div', {
    staticStyle: {
      "color": "#9b9b9b",
      "font-size": ".26rem",
      "margin-top": ".1rem",
      "word-break": "break-all"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.goodsDetail.detail) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "close-box",
    on: {
      "click": function($event) {
        return _vm.toggleProp('goodInfo')
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.previewPic) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.previewPic = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "pic-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.previewImgUrl
    },
    on: {
      "click": function($event) {
        _vm.previewPic = false
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.propSpecInfo) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        return _vm.toggleProp('specInfo', _vm.goodsDetail)
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.propSpecInfo) ? _c('div', {
    staticClass: "prop-box spec"
  }, [_c('div', {
    staticClass: "spec-close-btn",
    on: {
      "click": function($event) {
        _vm.propSpecInfo = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-info flexrow"
  }, [_c('img', {
    attrs: {
      "src": _vm.goodsDetail.image_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flexcol goods-des"
  }, [_c('div', {
    staticClass: "ellipse",
    staticStyle: {
      "font-size": "0.3rem",
      "color": "#4A4A4A",
      "font-weight": "bolder"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.goodsDetail.goods_name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "goods-spec"
  }, [_vm._v("已选: " + _vm._s(_vm.goodsDetail.specAttrStr))]), _vm._v(" "), (_vm.goodsDetail.activity_id > 0) ? _c('div', {
    staticClass: "red"
  }, [_vm._v("\n              ￥" + _vm._s(_vm.goodsDetail.activity_price) + "\n            ")]) : _c('div', {
    staticClass: "red"
  }, [_vm._v("￥" + _vm._s(_vm.goodsDetail.sales_price))])])]), _vm._v(" "), _c('div', {
    staticClass: "spec-content"
  }, [(_vm.goodsDetail.sku_list[0].specification && _vm.goodsDetail.sku_list[0].specification != '') ? _c('div', {
    staticClass: "spec-params"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "0.1rem"
    }
  }, [_vm._v("规格")]), _vm._v(" "), _c('ul', {
    staticClass: "flexrow"
  }, _vm._l((_vm.goodsDetail.sku_list), function(item) {
    return _c('li', {
      class: [{
        'selected': item.is_selected == 1
      }, {
        'disabled-spec': item.is_can_choose == 0
      }],
      on: {
        "click": function($event) {
          return _vm.handleSelect('spec', item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.specification) + "￥" + _vm._s(item.sales_price) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.goodsDetail.attribute_list), function(item) {
    return _c('div', {
      staticClass: "spec-params"
    }, [_c('p', [_vm._v("\n              " + _vm._s(item.attributeTypeName) + "\n              "), (item.addPrice == 1) ? _c('span', [_vm._v("(" + _vm._s(item.selectTips) + ")")]) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "flexrow"
    }, _vm._l((item.attributeList), function(item2) {
      return _c('li', {
        class: [{
          'selected': item2.is_selected
        }, {
          'disabled-spec': item2.saleStatus === 0
        }],
        on: {
          "click": function($event) {
            return _vm.handleSelect('attr', item2, item)
          }
        }
      }, [(item.addPrice == 1) ? _c('span', [_vm._v(_vm._s(item2.name) + "¥" + _vm._s(item2.salePrice))]) : _c('span', [_vm._v(_vm._s(item2.name))])])
    }), 0)])
  })], 2), _vm._v(" "), (_vm.goodsDetail.specifications.sales_status == 1 && _vm.goodsDetail.specifications.stock != 0) ? _c('div', {
    staticClass: "btn-yellow select-spec-alert-btn fixed",
    on: {
      "click": function($event) {
        return _vm.addGoods(_vm.goodsDetail)
      }
    }
  }, [_vm._v("选好了\n        ")]) : _c('div', {
    staticClass: "btn-gray select-spec-alert-btn fixed"
  }, [_vm._v("售罄")])]) : _vm._e(), _vm._v(" "), (_vm.isShowCartGoods) ? _c('div', {
    staticClass: "mask over",
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCartGoods) ? _c('div', {
    staticClass: "alert-box change-goods"
  }, [_c('img', {
    staticStyle: {
      "width": ".21rem",
      "height": ".21rem",
      "float": "right"
    },
    attrs: {
      "src": require("../assets/images/close-icon-pay.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change-tit"
  }, [_vm._v("以下商品发生了变化")]), _vm._v(" "), _c('div', {
    staticClass: "change-sec-tit"
  }, [_vm._v("你可以选购其他商品")]), _vm._v(" "), _vm._l((_vm.changeGoodsInCart), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "change-goods-item"
    }, [_c('div', {
      staticClass: "ellipse",
      staticStyle: {
        "max-width": "2.8rem"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.num == 0) ? _c('span', [_vm._v("下架/售罄")]) : _vm._e(), _vm._v(" "), (item.num > 0) ? _c('span', [_vm._v(_vm._s(item.message ? item.message : ('仅剩' + item.num + '份')))]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-yellow change-goods-btn",
    on: {
      "click": function($event) {
        _vm.isShowCartGoods = false
      }
    }
  }, [_vm._v("重新选购")])], 2) : _vm._e(), _vm._v(" "), (_vm.couponModalOpened) ? _c('div', {
    staticClass: "mask flex-row-cc",
    on: {
      "click": _vm.closeCouponModal
    }
  }, [_c('div', {
    staticClass: "dialog-coupon"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.couponInfo.coupon_pic
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-box"
  }, _vm._l((_vm.couponInfo.coupon_list), function(item) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "cnt flex-row-bc"
    }, [_c('div', [_c('div', {
      staticClass: "fs-46 fc-red fw-bold"
    }, [_vm._v(_vm._s(item.couponName))]), _vm._v(" "), _c('div', {
      staticClass: "fs-26",
      staticStyle: {
        "color": "#666",
        "padding-top": ".1rem"
      }
    }, [_vm._v(_vm._s(item.couponDes))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "1.65rem"
      }
    }, [_c('div', {
      staticClass: "fc-red ac fs-36"
    }, [_vm._v("¥"), _c('span', {
      staticClass: "fs-46 fw-bold fc-red"
    }, [_vm._v(_vm._s(item.couponAmount))]), _vm._v(_vm._s(item.decimal ? '.' + item.decimal : '') + "\n                  ")]), _vm._v(" "), (item.status === 1) ? _c('div', {
      staticClass: "get checked"
    }, [_vm._v("已领取")]) : _vm._e(), _vm._v(" "), (item.status === 2) ? _c('div', {
      staticClass: "get checked"
    }, [_vm._v("不可领")]) : _vm._e(), _vm._v(" "), (item.status === 0) ? _c('div', {
      staticClass: "get",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.receiveCoupon(item)
        }
      }
    }, [_vm._v("点击领取")]) : _vm._e()])])])
  }), 0)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showTip) ? _c('div', {
    staticClass: "sys_busy"
  }, [_c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../src/assets/images/wait.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.tips))])])]) : _vm._e(), _vm._v(" "), (_vm.showShopSearch) ? _c('div', {
    staticClass: "shop-search-body"
  }, [_c('div', {
    staticClass: "shop-header"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": function($event) {
        return _vm.closeShopSearch()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": ".18rem"
    },
    attrs: {
      "src": require("../assets/images/icon_black_back.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('img', {
    staticStyle: {
      "width": ".28rem"
    },
    attrs: {
      "src": require("../assets/images/home_icon_search_bg.png"),
      "mode": "widthFix"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "placeholder": "想吃什么搜一搜",
      "id": "keyword"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "blur": function($event) {
        return _vm.submitShopSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.searchResults.length > 0) ? _c('div', {
    staticClass: "search-list"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('ul', {
    staticClass: "goods-list"
  }, _vm._l((_vm.searchResults), function(item2) {
    return _c('li', {
      staticStyle: {
        "border": "none"
      }
    }, [_c('div', {
      staticClass: "goods-box",
      on: {
        "click": function($event) {
          return _vm.toggleProp('goodInfo', item2)
        }
      }
    }, [_c('div', {
      staticClass: "goods-img"
    }, [_c('div', {
      staticClass: "lazy goodimg",
      style: ({
        backgroundImage: 'url(' + item2.image_url + ')'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-des flexrow",
      staticStyle: {
        "padding-right": "0"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item2.goods_name))]), _vm._v(" "), (item2.activity_specification && item2.is_single_spec == 0) ? _c('p', [_vm._v("\n                    " + _vm._s(item2.activity_specification))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("销量 " + _vm._s(item2.sales_volume))]), _vm._v(" "), _c('div', {
      staticClass: "flexrow",
      staticStyle: {
        "justify-content": "space-between",
        "align-items": "center"
      }
    }, [(item2.activity_id > 0) ? _c('p', [_c('span', {
      staticClass: "price amounts",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item2.activity_price))]), _vm._v(" "), _c('del', [_vm._v("￥" + _vm._s(item2.price))])]) : _c('p', [_c('span', {
      staticClass: "price amounts",
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("￥" + _vm._s(item2.price))]), _vm._v(" "), (item2.is_single_spec == 0) ? _c('span', [_vm._v("起")]) : _vm._e()]), _vm._v(" "), (_vm.shopDetail.is_open == 1) ? _c('div', [(item2.sales_status == 1 && item2.stock > 0) ? _c('div', {
      staticClass: "num-box"
    }, [(item2.is_options == 1) ? _c('div', {
      staticClass: "btn-yellow select-spec-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleProp('specInfo', item2)
        }
      }
    }, [_c('span', [_vm._v("选规格")]), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
      staticClass: "num"
    }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e()]) : _c('div', [(item2.cartNum > 0) ? _c('span', {
      staticClass: "btns minusBtn icon-removecart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.minusGoods(item2)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item2.cartNum > 0) ? _c('span', {
      staticClass: "box"
    }, [_vm._v(_vm._s(item2.cartNum))]) : _vm._e(), _vm._v(" "), (item2.smallNumber > 1 && !item2.cartNum) ? _c('span', {
      staticClass: "btn-yellow select-spec-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addGoods(item2)
        }
      }
    }, [_vm._v(_vm._s(item2.smallNumber) + "份起购")]) : (!item2.noStock || item2.smallNumber <= 1 && !item2.cartNum) ? _c('span', {
      staticClass: "btns addBtn icon-addtocart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addGoods(item2)
        }
      }
    }) : _c('span', {
      staticClass: "btns addBtn icon-cantaddtocart"
    })])]) : _c('span', {
      staticClass: "num-box sales-out"
    }, [_vm._v("售罄")])]) : _vm._e()])]), _vm._v(" "), (item2.activity_desc) ? _c('div', {
      staticClass: "sale-box"
    }, [(item2.activity_desc && item2.activity_desc != '') ? _c('span', {
      staticClass: "no-bg"
    }, [_vm._v(_vm._s(item2.activity_desc))]) : _vm._e(), _vm._v(" "), (item2.activity_id > 0 && item2.sales_status == 1 && item2.left_stock <= 10) ? _c('span', {
      staticClass: "bg"
    }, [_vm._v("剩" + _vm._s(item2.left_stock) + "份")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "1.26rem",
        "margin-top": "0.1rem"
      }
    }, [(item2.partner != 0 && item2.activity_desc_extra) ? _c('span', {
      staticClass: "activity-tip"
    }, [_vm._v(_vm._s(item2.activity_desc_extra))]) : _vm._e(), _vm._v(" "), (item2.show_text) ? _c('span', {
      staticClass: "activity-tip"
    }, [_vm._v(_vm._s(item2.show_text))]) : _vm._e()])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.iShowSearchNothing) ? _c('div', {
    staticClass: "nothing"
  }, [_vm._v("抱歉，未能找到您搜索的商品")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/home_icon_search_bg.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#9b9b9b"
    }
  }, [_vm._v("搜索商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-content"
  }, [_c('img', {
    staticStyle: {
      "width": "2.37rem",
      "height": "2.42rem"
    },
    attrs: {
      "src": require("../../src/assets/images/icon_content.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("吃完记得给大厨一个反馈哦～")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "fixed closeShop"
  }, [_c('p', [_vm._v("店铺打烊，请其他方式下单或电话联系")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4896e1a6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/GoodsList.vue
// module id = 433
// module chunks = 7